import React from 'react';
import MainBody from '../templates/MainBody';
import { humintContent } from '../data';

const HUMINT: React.FC = () => {
  return <MainBody data={humintContent} />;
};

export default HUMINT;
